import React, { useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL, IMAGE_URL } from "../../redux/Constant";
import { getCart } from "../../store/cartSlice";

const PURPLE = "rgb(109 79 160)";

// Compact, single-line product row (image | name + subtitle | price | qty | add to cart)
const CartRow = ({ data, setShowSnackbar, setAddSuccessMsg, setAddErrorMsg }) => {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const increment = () => setCount(count + 1);
  const decrement = () => {
    if (count > 0) setCount(count - 1);
  };

  const addToCartFunc = async (productId, quantity) => {
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/add-to-cart`, {
        user_id: localStorage.getItem("user") ? localStorage.getItem("user") : "",
        product_ids: [productId],
        quantities: [quantity],
      });
      if (res.status === 200) {
        setLoading(false);
        setShowSnackbar(true);
        setTimeout(() => {
          setShowSnackbar(false);
          setAddSuccessMsg("");
        }, 2000);
        setAddSuccessMsg(res.data.message);
        const userId = res.data.user_id;
        localStorage.setItem("user", res.data.user_id);
        dispatch(getCart(userId));
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      if (err.response?.status === 404) {
        setShowSnackbar(true);
        setTimeout(() => {
          setShowSnackbar(false);
          setAddErrorMsg("");
        }, 2000);
        setAddErrorMsg("Out of stock");
      }
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "0.6rem 0.9rem",
        backgroundColor: "#F7F4F4",
        border: "1px solid #dad5d5",
        borderRadius: "6px",
        color: "#000",
        p: "0.5rem 0.8rem",
      }}
    >
      {/* Image */}
      <Box
        onClick={() => navigate(`/go-product/${data?.id}`)}
        sx={{
          flex: "0 0 auto",
          width: "64px",
          height: "56px",
          background: "#fff",
          border: "1px solid #dad5d5",
          borderRadius: "6px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <Box
          component="img"
          src={`${IMAGE_URL}/${data?.product_images ? data.product_images : ""}`}
          alt={data?.name}
          sx={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
        />
      </Box>

      {/* Name + subtitle */}
      <Box sx={{ flex: "1 1 150px", minWidth: 0 }}>
        <Typography sx={{ fontSize: "19px", fontFamily: "ABLE", lineHeight: "24px" }}>
          {data?.name}
        </Typography>
        <Typography
          component="em"
          sx={{ fontSize: "16px", fontFamily: "ABLE", lineHeight: "20px", display: "block" }}
        >
          {data?.subtitle}
        </Typography>
      </Box>

      {/* Price */}
      <Typography
        sx={{
          flex: "0 0 auto",
          minWidth: "56px",
          textAlign: "right",
          fontSize: "20px",
          fontFamily: "ABLE",
        }}
      >
        $ {data?.price}
      </Typography>

      {/* Quantity */}
      <Box sx={{ display: "flex", flex: "0 0 auto" }}>
        <Box
          sx={{
            border: `1px solid ${PURPLE}`,
            fontSize: "20px",
            fontFamily: "ABLE",
            borderRadius: "6px 0 0 6px",
            width: "56px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#fff",
          }}
        >
          {count}
        </Box>
        <Box
          sx={{
            background: PURPLE,
            borderRadius: "0 6px 6px 0",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <ExpandLess
            onClick={increment}
            sx={{ cursor: "pointer", width: "1.3rem", height: "1.3rem", color: "#fff" }}
          />
          <ExpandMore
            onClick={decrement}
            sx={{ cursor: "pointer", width: "1.3rem", height: "1.3rem", color: "#fff" }}
          />
        </Box>
      </Box>

      {/* Add to cart */}
      <Button
        disabled={count === 0 || loading}
        onClick={() => addToCartFunc(data?.id, count)}
        sx={{
          flex: "0 0 auto",
          width: { xs: "100%", md: "120px" },
          background: `${PURPLE} !important`,
          color: "#fff !important",
          fontFamily: "ABLE !important",
          fontSize: "16px !important",
          py: "0.55rem !important",
          lineHeight: "initial !important",
          "&.Mui-disabled": {
            cursor: "not-allowed",
            pointerEvents: "auto",
            color: "rgb(255 255 255 / 38%) !important",
          },
        }}
      >
        {loading ? (
          <CircularProgress
            sx={{ width: "22px !important", height: "22px !important", color: "#e4dbe7" }}
          />
        ) : (
          "Add to Cart"
        )}
      </Button>
    </Box>
  );
};

export default CartRow;
